import type { AppRouteRecordRaw } from "shared/types";
import { LAYOUTS, MODULE_SETTINGS, TEACHER_ROLES } from "shared/constants";
import { ADVISORY_ROUTE_NAMES } from "./routeNames";

const routes: AppRouteRecordRaw[] = [
  {
    // Optional tab segment: see the student-meeting detail route.
    path: "/my-meetings/:tab(open|completed)?/transition-meeting/:id",
    name: ADVISORY_ROUTE_NAMES.MY_MEETING,
    component: () =>
      import("meetings/advisory/pages/teacher/MyTransitionMeetingPage.vue"),
    meta: {
      title: "Mijn bespreking",
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      roleRequired: TEACHER_ROLES,
      settingRequired: [MODULE_SETTINGS.TRANSITION_MEETING],
      hideTitle: true,
      exactRouteIdentifier: "myMeetings",
    },
  },
];

export default routes;
